// extracted by mini-css-extract-plugin
export default {"product-detail":"ProductDetail_product-detail__ZUxZ2","product-image":"ProductDetail_product-image__rBaNl","product-info":"ProductDetail_product-info__9-RE4"};